<template>
  <div class="layout-box">
    <LayoutHeader headtitle="行业图谱"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-title">
        <div class="bread-crumb-nav">当前位置：<a @click="$router.go(-1)">首页</a> > 行业图谱</div>
      </div>
      <ul class="experts-list clear">
        <li v-for="(item,index) in datas" :key="index" @click="hanle(item.name,item.titles)">
          <img :src='item.img' />
<!--          <h3>{{ item.titles }}</h3>-->
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";
export default {
  name: 'IndustryMap',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      datas:[
        {img:require('../../assets/img/map-pta2.jpg'),titles:'PTA产业链',name:'map-pta'},
        {img:require('../../assets/img/map-rtzf2.jpg'),titles:'涤纶长丝熔体直纺工艺',name:'map-rtzf'},
        {img:require('../../assets/img/map-csqp2.jpg'),titles:'涤纶长丝切片纺工艺',name:'map-csqp'},
        {img:require('../../assets/img/map-trq2.png'),titles:'天然气',name:'map-trq'},
        {img:require('../../assets/img/map-yyy2.png'),titles:'原油-原盐',name:'map-yyy'},
        // {img:require('../../assets/img/map-lh2.png'),titles:'硫磺',name:'map-lh.png'},
        {img:require('../../assets/img/map-m2.png'),titles:'煤',name:'map-m'}
      ]
    }
  },
  methods: {
    hanle(index,n) {
      localStorage.setItem('mapdata',index)
      localStorage.setItem('mapdataname',n)
      this.$router.push('/industrymapd')
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
}

.secondary-content{
  width: 1100px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.bread-crumb-nav{
  font-size: 16px;
  color: #fff;
  font-family: 微软雅黑;
  line-height: 59px;
  padding-left: 20px;
}

.bread-crumb-nav a{
  cursor: pointer;
  color: #fff;
  text-decoration: none;
}
.bread-crumb-nav a:hover{
  text-decoration: underline;
  font-weight: bold;
}

.experts-list{
  overflow: auto;
  height: calc(100% - 80px);
  padding: 30px 0 0 18px;
}

.experts-list::-webkit-scrollbar{
  display: none;
}

.experts-list li{
  width: 488px;
  padding: 10px;
  margin: 0 12px 25px 12px;
  background: #E3E9F6;
  cursor: pointer;
  box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  float: left;
  text-align: center;
}

.experts-list li:hover{
  background: #fff;
  border: 2px solid #2095EF;
  padding: 8px;
}

.experts-list li img{
  width: 100%;
}

.experts-list li h3{
  line-height: 52px;
  font-size: 21px;
}

</style>




// WEBPACK FOOTER //
// src/views/secondary/secondary-Industrymap-list.vue